/**
* Created by lobin on 2020/7/14.
*/
<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
    <div style="display: flex;justify-content: space-between">
      <div>
          <a-button type="default" icon="plus" @click="addCustomer">添加</a-button>
      </div>
      <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
        <a-form-model-item>
          <station-select type="input" v-model="search.station" />
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.name" placeholder="客户姓名" allowClear style="width: 100px"></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.phone" placeholder="客户电话" allowClear style="width: 120px"></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-select default-value="" style="width: 120px" v-model="search.hasName" placeholder="是否有姓名" allowClear>
            <a-select-option value="">
              全部
            </a-select-option>
            <a-select-option :value="'true'">
              是
            </a-select-option>
            <a-select-option :value="'false'">
              否
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-select default-value="" style="width: 120px" v-model="search.multipaly" placeholder="是否尾号相同" allowClear>
            <a-select-option value="">
              全部
            </a-select-option>
            <a-select-option :value="1">
              是
            </a-select-option>
            <a-select-option :value="2">
              否
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-select default-value="" style="width: 120px" v-model="search.hasAdress" placeholder="是否有地址" allowClear>
            <a-select-option value="">
              全部
            </a-select-option>
            <a-select-option :value="'true'">
              是
            </a-select-option>
            <a-select-option :value="'false'">
              否
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-select :default-value="0" style="width: 100px" v-model="search.inblacklist" placeholder="黑名单">
            <a-select-option :value="0">
              正常
            </a-select-option>
            <a-select-option :value="1">
              黑名单
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            type="primary"
            html-type="submit"
            icon="search"
          >
            查询
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
		<a-divider />
		<a-table
			:loading="listloading"
			:columns="columns"
			:data-source="list"
			:scroll="{y: 500, x: 1700 }"
			:pagination="pager"
			@change="change">
			<span slot="user" slot-scope="text, record">
          <a-avatar :src="record.headimgurl" />
          <span style="margin-left: 10px">{{ record.nickname }}</span>
			</span>
			<span slot="inblacklist" slot-scope="text">
				<a-tag color="#f50" v-if="text">黑名单</a-tag>
				<a-tag color="#87d068" v-else>正常</a-tag>
			</span>
      <span slot="multipaly" slot-scope="text">
				<a-tag color="#f50" v-if="text">是</a-tag>
				<a-tag color="#87d068" v-else>否</a-tag>
			</span>
      <span slot="etype" slot-scope="text">
        <div style="display: flex; gap: 5px; width: 130px;flex-wrap: wrap;">
          <span v-for="value in getEtypes(text)" :key="value.key" style="display: flex;align-items: center;">
            <img :src="value.img" :alt="value" style="width: 16px; height: 16px; margin-right: 2px;" />
            <span style="font-weight: bold;">:</span>
            <span style="font-weight: bold;">{{ value.count }}</span>
          </span>
        </div>
			</span>
      <span slot="phone" slot-scope="text,record">
        <a-space :size="10" direction="vertical">
          <a-space :size="10" direction="horizontal">
            {{ text }}
            <a-icon type="search" @click="updateCustomerName(text, record._id, record.station.id)"></a-icon>
          </a-space>
          <div>
            <a-tag color="blue">{{ record.province }}-{{ record.city }}</a-tag>
            <a-tag color="red">{{ record.op }}</a-tag>
          </div>
        </a-space>
			</span>
			<span slot="tages" slot-scope="text">
				<a-tag color="red" v-for="item in text" :key="item" style="margin-left: 2px">{{ item }}</a-tag>
			</span>
			<span slot="action" slot-scope="text, record">
        <a @click="modifycustomer(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="deleteCustom(record)">删除</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item key="0">
              <a @click="pickTages(record)" v-has:shieldCustom>打标签</a>
            </a-menu-item>
            <a-menu-item key="1">
              <a v-has:shieldCustom  @click="unbind(record)">{{ record.inblacklist ? '移除黑名单' : '加入黑名单' }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
			</span>
		</a-table>
    <a-modal
      title="编辑标签"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
    <a-select mode="tags" style="width: 100%" placeholder="Tags Mode" v-model="tages">
      <a-select-option v-for="i in defaultTages" :key="i">
        {{ i }}
      </a-select-option>
    </a-select>
    </a-modal>
    <a-modal
      :title="modifyType == 'add' ? '添加' : '编辑'"
      :visible="modifyVisible"
      @ok="handleSubmit"
      @cancel="modifyVisible = false"
      :inline="false"
    >
      <a-form-model 
        :model="customform"
        label-position="left"
        :label-col="labelCol"
        :rules="rules"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="站点" prop="station">
          <station-select type="input" v-model="customform.station" />
        </a-form-model-item>
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="customform.name" placeholder="输入客户姓名" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item label="电话" prop="phone">
          <a-input v-model="customform.phone" placeholder="输入客户电话" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item label="地址" prop="address">
          <a-input v-model="customform.address" placeholder="输入收件人地址" allowClear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      title="更新收件人信息"
      :visible="uvisible"
      @ok="udialogSubmit"
      @cancel="handleUdialogCancel"
    >
      <div style="display: flex; justify-content: center;">
        <barcode 
          :value="customUpdateform.code" 
          format="CODE128" 
          :options="{
            size: 100,
          }"
        >
          Show this if the rendering fails.
        </barcode>
      </div>
      <a-form :form="customUpdateform" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
        <a-form-model-item label="姓名" prop="name">
          <a-input 
            v-model="customUpdateform.name" 
            placeholder="输入客户姓名" 
            allowClear 
            prop="name"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="电话" prop="phone">
          <a-input 
            v-model="customUpdateform.phone" 
            placeholder="输入客户电话" 
            allowClear 
            prop="phone"
          ></a-input>
        </a-form-model-item>
      </a-form>
    </a-modal>
	</a-card>
</template>

<script type="text/babel">
import {
  stationUser, 
  shieldStationUser, 
  updateTages, 
  updateCustomerName,
  updateCustomer,
  creatCustomer,
  deleteCustomer,
} from '@/api/user';
import barcode from 'vue-barcode';
import pdd from '../../assets/pdd.jpeg';
import taobao from '../../assets/taobao.jpg';
import jd from '../../assets/jd.jpg';
import other from '../../assets/other.jpg';
import douyin from '../../assets/douyin.png';
export default {
  components: {
    barcode
  },
  data() {
    return {
      listloading: false,
      list: [],
      pager: {},
      search: {},
      searchRange: [],
      visible: false,
      confirmLoading: false,
      uvisible: false,
      tages: [],
      modifyVisible: false,
      customform: {},
      customUpdateform: {},
      modifyType: 'add',
      id: '',
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      defaultTages: ['有尾号相同', '爱投诉', '大客户','虚拟号'],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    columns() {
      return [
	      {
		      title: '#',
		      dataIndex: 'index',
		      customRender: (text, row, index) => index + 1,
		      key: 'index',
		      width: '50px',
	      },
        {
          title: '站点',
          dataIndex: 'station.name',
          key: 'stationName',
        },
        {
          title: '用户姓名',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '电话',
          dataIndex: 'phone',
          key: 'phone',
          width: '200px',
          scopedSlots: { customRender: 'phone' },
        },
        {
          title: '多用户',
          dataIndex: 'multipaly',
          scopedSlots: { customRender: 'multipaly' },
          key: 'multipaly',
        },
        {
          title: '包裹计数',
          dataIndex: 'count',
          key: 'count',
        },
        {
          title: '渠道计数',
          dataIndex: 'etype',
          key: 'etype',
          width: 150,
          scopedSlots: { customRender: 'etype' },
        },
        {
          title: '上次投递时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
        },
        {
          title: '是否拉黑',
          dataIndex: 'inblacklist',
          scopedSlots: { customRender: 'inblacklist' },
          key: 'inblacklist',
        },
        {
          title: '标签',
          dataIndex: 'tages',
          key: 'tages',
	        scopedSlots: { customRender: 'tages' },
        },
        {
          title: '地址',
          dataIndex: 'address',
          key: 'address',
        },
	      {
		      title: '操作',
		      key: 'action',
		      fixed: 'right',
		      width: 220,
		      scopedSlots: { customRender: 'action' },
	      },
      ];
    },
    rules() {
      return {
        station: [
          { required: true, message: '请选择所属小区', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入客户电话', trigger: 'blur' },
        ],
        name: [
          { required: false, message: '请输入客户姓名', trigger: 'blur' },
        ],
        address: [
          { required: false, message: '请输入客户地址', trigger: 'blur' },
        ],
      };
    },
  },
  methods: {
    getEtypeImg(type) {
      if (type == 'taobao') {
        return taobao;
      }
      if (type == 'jd') {
        return jd;
      }
      if (type == 'pdd') {
        return pdd;
      }
      if (type == 'douyin') {
        return douyin;
      }
      if (type == 'other') {
        return other;
      }
    },
    getEtypes(etype) {
      const result = [];
      for(const key in etype) {
        result.push({
          key,
          img: this.getEtypeImg(key),
          count: etype[key],
        })
      }
      return result.sort((a, b) => b.count - a.count);
    },
    addCustomer() {
      this.modifyVisible = true;
      this.modifyType = 'add';
      this.customform = {};
    },
    modifycustomer(row) {
      this.customform = {
        name: row.name,
        phone: row.phone,
        address: row.address,
        station: row.station._id,
        id: row._id,
      };
      this.modifyVisible = true;
      this.modifyType = 'modify';
    },
    handleUdialogCancel() {
      this.customUpdateform = {};
      this.uvisible = false;
    },
    async udialogSubmit() {
      const { id, name, phone, station } = this.customUpdateform;
      if(!name) {
        return this.$message.error('请填写姓名');
      }
      await updateCustomer({
        id,
        name,
        phone,
        station,
      })
      this.$message.success('操作成功');
      this.uvisible = false;
      this.getList();
    },
    async handleSubmit() {
      let res;
      try {
        if (this.modifyType === 'add') {
          res = await creatCustomer(this.customform);
        } else {
          res = await updateCustomer(this.customform);
        }
      } catch (error) {
        console.log(error);
      }
      if(res.code === 0) {
          this.$message.success('操作成功');
        this.getList();
        this.modifyVisible = false;
      }
    },
    async handleOk() {
      if (this.tages.length === 0) {
        this.visible = false;
      }
      this.confirmLoading = true;
      try {
        await updateTages(this.id, {
          tages: this.tages,
        });
        this.$message.success('设置成功');
        this.getList();
      } catch (error) {
        this.$message.error(error.message);
      }
      this.confirmLoading = false;
      this.visible = false;
    },
    handleCancel() {
      this.visible = false,
      this.confirmLoading = false;
    },
    async getList() {
      this.listloading = true;
      const q = { ...this.search };
      // eslint-disable-next-line prefer-destructuring
      q.start = this.searchRange[0];
      // eslint-disable-next-line prefer-destructuring
      q.end = this.searchRange[1];
      try {
        const { data: { docs, pager } } = await stationUser(q);
        this.list = docs;
        this.pager = {
	        ...pager,
	        showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        console.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
    async updateCustomerName(phone, id, station) {
      const hide = this.$message.loading('获取数据中...', 0);
      const res = await updateCustomerName(phone, station);
      hide();
      if (res.code == 0) {
        console.log('res', res);
        if(res.data.code === 7001) {
          this.$message.error(res.data.message);
        } else if(res.data.code === 9000) {
          this.uvisible = true;
          this.customUpdateform.name = '';
          this.customUpdateform.id = id;
          this.customUpdateform.code = res.data.data.code;
          this.customUpdateform.phone = phone;
          this.customUpdateform.station = station;
          this.$message.success(res.data.message);
        } else {
          this.$message.success('更新成功');
        }
        this.getList();
      }
    },
	  async unbind(data) {
    	const id = data._id;
    	const post = { inblacklist: !data.inblacklist };
    	await shieldStationUser(id, post);
    	this.$message.success('操作成功');
	    this.getList();
	  },
	  async pickTages({ tages, _id }) {
      this.id = _id;
      this.tages = tages;
      this.visible = true;
      // this.$message.info('开发中');
	  },
    async deleteCustom(row) {
      const id = row._id;
      await deleteCustomer(id);
      this.$message.success('删除成功');
      this.getList();
    }
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.user-list {

	}
</style>
